import { createContext, useContext, useMemo, useState } from "react";

export const NavbarContext = createContext();

export function NavbarProvider({ children }) {
  const [hideNavbar, setHideNavbar] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  const value = useMemo(
    () => ({
      hideNavbar,
      setHideNavbar,
      activeSection,
      setActiveSection,
    }),
    [hideNavbar, activeSection]
  );

  return (
    <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
  );
}

export function useNavbar() {
  return useContext(NavbarContext);
}
